import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TProjectEnergyDemandBuildings } from 'domain/types/energyDemand';
import undoable, { combineFilters, excludeAction } from 'redux-undo';
import { resetAll } from 'state/resetAction';
import { TUndoRedoOptions } from 'state/slices/types';

export interface EnergyDemandState {
  buildings: TProjectEnergyDemandBuildings;
}

const initialState: EnergyDemandState = {
  buildings: {},
};

export const energyDemandSlice = createSlice({
  name: 'energyDemand',
  initialState,
  reducers: {
    // Generic
    clear: () => initialState,
    clearHistory: (_state, _action: PayloadAction<TUndoRedoOptions>) => {},
    undo: (_state, _action: PayloadAction<TUndoRedoOptions>) => {},
    redo: (_state, _action: PayloadAction<TUndoRedoOptions>) => {},
    // Available
    setEnergyDemandBuildings: (state, action) => {
      state.buildings = action.payload;
    },
    setEnergyDemandBuildingsWithoutHistory: (state, action) => {
      state.buildings = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAll, () => initialState);
  },
});

export const {
  // Generic
  clearHistory: clearEnergyDemandHistory,
  undo: undoEnergyDemand,
  redo: redoEnergyDemand,
  // Available
  setEnergyDemandBuildings,
  setEnergyDemandBuildingsWithoutHistory,
} = energyDemandSlice.actions;

export const energyDemandReducer = undoable(energyDemandSlice.reducer, {
  filter: combineFilters(
    (action) => action.type.startsWith(energyDemandSlice.name + '/'),
    excludeAction([
      // Generic
      energyDemandSlice.actions.clear.type,
      energyDemandSlice.actions.clearHistory.type,
      energyDemandSlice.actions.undo.type,
      energyDemandSlice.actions.redo.type,
      // Available
      energyDemandSlice.actions.setEnergyDemandBuildingsWithoutHistory.type,
    ]),
  ),
  clearHistoryType: energyDemandSlice.actions.clearHistory.type,
  undoType: energyDemandSlice.actions.undo.type,
  redoType: energyDemandSlice.actions.redo.type,
});
